/*
    THIS FILE WAS DEVELOPED BY MEHMET GUDUK
    © 2022 COPYRIGHT, LICENSED WITH GPL-3.0 LICENSE, AUTHOR IS MEHMET GUDUK
    https://github.com/mehmetguduk
*/

import React from 'react';

export default function Interests() {
    return (
        <div className="interests">
            <h3 className="interests-title">Interests</h3>
            <p className="interests-content">
                Researcher. Reader. Internet fanatic. Gamer. Music listener. Travel geek. Coffee fanatic. Breakfast buff.
            </p> 
        </div>
    )
}